import { Col, Sidepanel, Spinner2 } from 'components';
import { theme } from 'lib';
import { useSelector } from 'react-redux';
import { ContentHeader } from '../';
import { AthleteTier } from './components';

const PricingPanel = ({ dataId, setDataId, closeModal, panelHeader }) => {
  const storedData = useSelector((state) =>
    state.admin?.athleteTiers?.find((x) => x._id === dataId)
  );

  return (
    <Sidepanel wid="800" pad="0" visible={dataId} closeModal={closeModal}>
      <ContentHeader
        text={
          !storedData
            ? `${panelHeader} - Add Tier`
            : `${panelHeader} - Edit ${storedData?.name || 'Tier'}`
        }
        closePanel={closeModal}
      />

      {dataId && (typeof dataId === 'string' ? !storedData : false) && (
        <Col
          zIndex={5}
          pos="absolute"
          ht="100%"
          wid="100%"
          bg="rgba(210, 216, 223, 0.7)"
          left="0"
          centerAll
        >
          <Spinner2 col={theme.SECONDARY} />
        </Col>
      )}

      {dataId && (typeof dataId === 'string' ? storedData : true) && (
        <AthleteTier
          tier={storedData}
          setDataId={setDataId}
          closeModal={closeModal}
          isEditing={!!storedData}
          panelHeader={panelHeader}
        />
      )}
    </Sidepanel>
  );
};

export default PricingPanel;
